var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7664 7.64328C18.2238 7.17592 17.9716 6.36309 17.3394 6.26631L12.4554 5.52393C12.2044 5.48534 11.9877 5.32057 11.8754 5.0823L9.69108 0.449749C9.40851 -0.149916 8.59175 -0.149916 8.3086 0.449749L6.12485 5.0823C6.01251 5.32057 5.79528 5.48595 5.54423 5.52393L0.660878 6.26631C0.0286776 6.36248 -0.224088 7.17592 0.233871 7.64328L3.76743 11.2492C3.94912 11.4342 4.03165 11.7013 3.98924 11.9634L3.15471 17.0548C3.04696 17.7138 3.70782 18.2167 4.27353 17.9056L8.64161 15.5014C8.86572 15.3783 9.13453 15.3783 9.35864 15.5014L13.7267 17.9056C14.2924 18.2167 14.9533 17.7138 14.8455 17.0548L14.011 11.9634C13.968 11.7013 14.0511 11.4342 14.2328 11.2492L17.7664 7.64328Z",
    fill: "#FECA57"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.3217 11.0312C9.36469 10.7696 9.28216 10.5025 9.10046 10.317L5.56633 6.711C5.21613 6.3539 5.28319 5.79405 5.61735 5.508C5.59327 5.51412 5.5692 5.51963 5.54398 5.52331L0.660623 6.26631C0.0284235 6.36247 -0.223769 7.17591 0.233616 7.64266L3.76717 11.2486C3.94887 11.4342 4.03197 11.7013 3.98899 11.9628L3.15503 17.0548C3.04671 17.7138 3.70756 18.2167 4.27328 17.9056L8.58462 15.5326L9.3217 11.0312Z",
    fill: "#F4B537"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99397 5.33466L10.8773 4.59166C11.1203 4.55491 11.3307 4.3981 11.4459 4.17208L9.69145 0.449749C9.4083 -0.149916 8.59155 -0.149916 8.30898 0.449749L6.12465 5.0823C6.07421 5.18888 6.00199 5.28014 5.91602 5.35242C5.94123 5.34568 5.96703 5.33895 5.99397 5.33466Z",
    fill: "#F4B537"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.618710993a5abd09050b49a1920d3ff2.svg";
export { ForwardRef as ReactComponent };